module.exports = __webpack_public_path__ + "fonts/CeraPro-Medium.6c7be939.woff";